/* ============================================================
   FOOTER — accordeons en het nieuwsbriefformulier.

   t-accordeon    de menukolommen; op mobiel dicht, op desktop zet de CSS ze
                  open en verbergt de knop. De JS regelt alleen het klappen en
                  de aria-status, dus zonder JavaScript blijft alles leesbaar
                  zodra de CSS de kolom opent.
   c-form-newsletter  validatie van het e-mailadres en de toestemming, met de
                  foutteksten uit de data-attributen. Zonder JavaScript doet de
                  browser het met required en type="email".
   ============================================================ */

class Accordeon extends HTMLElement {
  connectedCallback() {
    this.knop = this.querySelector('[data-accordeon-toggle]');
    this.lijf = this.querySelector('[data-accordeon-body]');
    if (!this.knop || !this.lijf) return;
    this.knop.addEventListener('click', () => this.wissel());
    /* Eerst het breakpunt bepalen, dan pas de hoogte zetten: boven het breakpunt
       zet de CSS de kolom open en mag er geen max-height op staan, anders knipt
       die de lijst af.

       768 px en niet 1024: de footer-CSS verbergt de plus/min al vanaf 768
       (`@media (min-width:768px) { .footer-menu__title .footer-menu__toggle
       { display:none } }`). Neem je hier 1024, dan staat de kolom tussen 768 en
       1024 dicht zonder knop om hem te openen. */
    this.venster = window.matchMedia('(min-width: 768px)');
    this.venster.addEventListener('change', () => this.zetHoogte());
    this.zetHoogte();
  }

  get open() { return !this.classList.contains('is-close'); }

  wissel() {
    this.classList.toggle('is-close');
    this.knop.setAttribute('aria-expanded', this.open ? 'true' : 'false');
    this.zetHoogte();
  }

  /* Een kolom die ook op desktop dichtgeklapt is (is-close-desktop) blijft overal
     een accordeon en houdt dus zijn max-height. Alleen de gewone kolommen laten
     boven het breakpunt de CSS het werk doen. */
  get altijdAccordeon() { return this.classList.contains('is-close-desktop'); }

  zetHoogte() {
    if (this.venster && this.venster.matches && !this.altijdAccordeon) {
      this.lijf.style.maxHeight = '';
      return;
    }
    const marge = Number(this.lijf.dataset.accordeonBodyPb || 0);
    this.lijf.style.maxHeight = this.open ? `${this.lijf.scrollHeight + marge}px` : '0px';
  }
}

class FormNewsletter extends HTMLElement {
  connectedCallback() {
    this.form = this.querySelector('form');
    this.email = this.querySelector('input[type="email"]');
    this.akkoord = this.querySelector('input[type="checkbox"]');
    this.foutEmail = this.querySelector('.message--error [data-error-text]');
    this.foutAkkoord = this.querySelector('.message--error-cgv [data-error-text]');
    this.knop = this.querySelector('button[type="submit"]');
    if (!this.form || !this.email) return;
    /* De verzendknop staat uit tot er akkoord is gegeven. Dat zet de JS, niet de
       HTML: zonder JavaScript blijft de knop bruikbaar en houdt het required op
       de checkbox de verzending tegen. Zo staat hij ook in het origineel. */
    if (this.akkoord && this.knop) {
      this.knop.disabled = !this.akkoord.checked;
      this.akkoord.addEventListener('change', () => {
        this.knop.disabled = !this.akkoord.checked;
        this.controleerAkkoord();
      });
    }
    this.email.addEventListener('blur', () => this.controleerEmail());
    this.email.addEventListener('input', () => this.wisFout());
    this.form.addEventListener('submit', (e) => {
      if (!this.controleerEmail() || !this.controleerAkkoord()) e.preventDefault();
    });
  }

  controleerEmail() {
    const waarde = this.email.value.trim();
    if (!waarde) return this.meld(this.foutEmail, this.dataset.errorEmailEmpty);
    const geldig = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(waarde);
    if (!geldig) return this.meld(this.foutEmail, this.dataset.errorEmail);
    this.email.setAttribute('aria-invalid', 'false');
    if (this.foutEmail) this.foutEmail.textContent = '';
    return true;
  }

  controleerAkkoord() {
    if (!this.akkoord || this.akkoord.checked) {
      if (this.foutAkkoord) this.foutAkkoord.textContent = '';
      return true;
    }
    if (this.foutAkkoord) this.foutAkkoord.textContent = this.dataset.errorCgv || '';
    return false;
  }

  meld(vak, tekst) {
    this.email.setAttribute('aria-invalid', 'true');
    if (vak) vak.textContent = tekst || '';
    return false;
  }

  wisFout() {
    this.email.setAttribute('aria-invalid', 'false');
    if (this.foutEmail) this.foutEmail.textContent = '';
  }
}

for (const [naam, klasse] of [
  ['t-accordeon', Accordeon],
  ['c-form-newsletter', FormNewsletter],
  ['cookie-consent-button', class extends HTMLElement {}],
]) {
  if (!customElements.get(naam)) customElements.define(naam, klasse);
}
